<template>
  <div class="munitions">
    <div class="munitions-cartridge" v-for="item in munitions"></div>
  </div>
</template>

<script>
  export default {
    name: 'Munitions',
    props: ['munitions']
  }
</script>



// WEBPACK FOOTER //
// src/components/Munitions.vue